export const REVENUE_SCALES = [
  { id: '1', name: '3億円未満' },
  { id: '2', name: '3億円以上10億円未満' },
  { id: '3', name: '10億円以上20億円未満' },
  { id: '4', name: '20億円以上50億円未満' },
  { id: '5', name: '50億円以上100億円未満' },
  { id: '6', name: '100億円以上500億円未満' },
  { id: '7', name: '500億円以上1000億円未満' },
  { id: '8', name: '1000億円以上' },
];
